// extracted by mini-css-extract-plugin
export default {"hosted":"style_hosted__qGe86"};